import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withAppContext } from '@ctsu/loader';
import {
  getVersions,
  getPioVersions,
  VERSION_ACTIONS
} from 'actions/protocols/version';
import * as selectors from 'selectors';
import _ from 'lodash';
import { RenderControl } from 'components/RenderHelpers';
import { bindLogger } from 'helpers/BindLogger';
import { CanUserAccessVersions, CanUserAccessPIOVersions } from 'appconstants/Permission';
import { PIOVersions, LocalVersions } from './components';

const loadingVersions = selectors.createLoadingSelector([
  VERSION_ACTIONS.GET_VERSIONS
]);
const loadingPIOVersions = selectors.createLoadingSelector([
  VERSION_ACTIONS.GET_PIO_VERSIONS
]);
const errorVersions = selectors.createErrorMessageSelector([
  VERSION_ACTIONS.GET_VERSIONS
]);
const errorPIOVersions = selectors.createErrorMessageSelector([
  VERSION_ACTIONS.GET_PIO_VERSIONS
]);

const Versions = props => {
  const {
    context,
    protocolNumber,
    protocolId,
    localVersions,
    pioVersions,
    onGetVersions,
    onGetPioVersions,
    isLoadingPrtDetails,
    iserrorPrtDetails,
    isloadingVersions,
    isloadingPIOVersions,
    iserrorVersions,
    iserrorPIOVersions
  } = props;

  const localDates = _.compact(_.map(pioVersions.data, 'localDate'));

  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetVersions, context)(protocolNumber);
      bindLogger(onGetPioVersions, context)(protocolNumber);
    }
  }, [
    protocolNumber,
    onGetVersions,
    onGetPioVersions,
    context
  ]);

  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="Version(s)"
      permission={CanUserAccessVersions()}
    >
      <Grid container alignItems="center" spacing={4}>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isloadingVersions}
            iserror={iserrorVersions}
            compName="Version(s)"
            permission={CanUserAccessVersions()}
          >
            <LocalVersions
              data={localVersions.data}
              pioInfo={pioVersions.data}
              localDates={localDates}
              protocolId={protocolId}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isloadingPIOVersions}
            iserror={iserrorPIOVersions}
            compName="PIO Version(s)"
            permission={CanUserAccessPIOVersions()}
          >
            <PIOVersions data={pioVersions.data} />
          </RenderControl>
        </Grid>
      </Grid>
    </RenderControl>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    localVersions: state.versions.localVersions,
    pioVersions: state.versions.pioVersions,
    isloadingVersions: loadingVersions(state),
    iserrorVersions: errorVersions(state),
    isloadingPIOVersions: loadingPIOVersions(state),
    iserrorPIOVersions: errorPIOVersions(state),
    protocolId: selectors.ProtocolIdSelector(state),
    protocolNumber: selectors.ProtocolNumSelector(state),
    isLoadingPrtDetails: selectors.lSelectorGetProtDetails(state),
    iserrorPrtDetails: selectors.eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetVersions: getVersions,
      onGetPioVersions: getPioVersions
    },
    dispatch
  )
);

const VersionsContainer = compose(
  withConnectState,
  withAppContext
)(Versions);

export default VersionsContainer;
